// @avantia common-code
import { getFunctionName, voidFunction } from '@avantia/client-and-server-utilities';
import { HpLoggerFunction } from '@avantia/logging-and-errors';
import {
  getFunctionRef,
  HpFuncRefResolverFunction,
  HpProcessSectionDynamicPropertyProps,
  HpSectionMap,
  isFunctionRef,
  sectionsDynamicPropertyWalker
} from '@avantia/questionset-model';
import { HpClientDebugFlags } from '../clientDebugFlags';
import { logDebug, logInfo } from '../clientLogging';

export interface HpSectionScriptResolverProps {
  debugMode: boolean;
  funcRefResolver: HpFuncRefResolverFunction;
  sections: HpSectionMap;
}

export function sectionScriptResolver({ debugMode, funcRefResolver, sections }: HpSectionScriptResolverProps): void {
  function resolveScriptReference<ParentT, GrandParentT>({
    expr,
    propertyName,
    index,
    parent
  }: HpProcessSectionDynamicPropertyProps<ParentT, GrandParentT>): void {
    if (isFunctionRef(expr)) {
      const func = funcRefResolver(getFunctionRef(expr) as string);
      const debugOut = debugMode ? output : voidFunction;
      if (propertyName && index !== undefined) {
        debugOut(expr, parent[propertyName][index], func);
        parent[propertyName][index] = func;
      } else if (propertyName) {
        debugOut(expr, parent[propertyName], func);
        parent[propertyName] = func as any;
      } else if (index !== undefined) {
        debugOut(expr, parent[index], func);
        parent[index] = func;
      }
    } else {
      const exprType = typeof expr;
      if (exprType === 'function') {
        return;
      } else if (exprType === 'string') {
        if (propertyName === 'helpText' || propertyName === 'infoText' || propertyName === 'text') {
          return;
        }
      }

      throw new Error(`Unhandled expression "${expr}".`);
    }
  }

  const logWalker: HpLoggerFunction = (msg) => logDebug(msg, HpClientDebugFlags.PayloadMapper);
  sectionsDynamicPropertyWalker({ sections, processor: resolveScriptReference, logInfo: logWalker });
}

// eslint-disable-next-line @typescript-eslint/ban-types
function output(expr: string, value: any, func: Function): void {
  logInfo(`"${expr}" -> "${value}" -> ${getFunctionName(func)}`, HpClientDebugFlags.PayloadMapper);
}
